
import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'ExitModal',
})
export default class ExitModal extends Vue {}
